<template>
  <div>
    <button class="share__icon" @click="favoriteContent">
      <i v-if="favorited" class="fas fa-bookmark"></i>
      <i v-else class="far fa-bookmark"></i>
    </button>
    <modal-login ref="modal"></modal-login>
  </div>
</template>

<script>
import ModalLogin from '../favorites/ModalLogin'

export default {
  props: {
    contentId: {
      type: String,
      default: null
    },
  },

  components: {
    ModalLogin
  },

  data: () => ({
    favoriteId: null,
    needLogin: true
  }),

  computed: {
    favorited() {
      return this.favoriteId !== null
    },

    requestParams() {
      return {
        content_id: this.contentId
      }
    }
  },

  created() {
    this.checkFavorite()
  },

  methods: {
    addToFavoriteList() {
      this.axios.post('/api/v1/favorites', this.requestParams).then(({ data }) => {
        this.favoriteId = (data || {}).id || null
      })
    },

    checkFavorite() {
      this.axios.get('/api/v1/favorites/check', { params: this.requestParams } ).then(({ data }) => {
        this.needLogin = false
        this.favoriteId = (data || {}).id || null
      }).catch(() => {
        this.needLogin = true
      })
    },

    removeToFavoriteList() {
      this.axios.delete(`/api/v1/favorites/${this.favoriteId}`).then(() => {
        this.favoriteId = null
      })
    },

    favoriteContent() {
      if(this.needLogin){
        this.openModal()
      } else {
        this.toggleFavorite()
      }
    },

    openModal() {
      this.$refs.modal.open()
    },

    toggleFavorite() {
      if (this.favorited) {
        this.removeToFavoriteList()
      } else {
        this.addToFavoriteList()
      }
    },

  }
}
</script>
